import { ChipVariants } from 'core-system/Chip'
import {
  FleetCardReplacementReason,
  FleetCardSummary,
} from 'redux/employee/employeeTypes'

export const FLEET_CARD_REPLACEMENT_REASONS: {
  id: FleetCardReplacementReason
  text: string
  physicalOnly?: boolean
}[] = [
  { id: 'lost', text: 'Lost' },
  { id: 'stolen', text: 'Stolen' },
  { id: 'damaged', text: 'Damaged', physicalOnly: true },
  { id: 'expired', text: 'Expired' },
]

export const FLEET_CARD_TYPE_OPTIONS: { id: 'physical' | 'virtual'; text: string }[] =
  [
    { id: 'virtual', text: 'Virtual' },
    { id: 'physical', text: 'Physical' },
  ]

export const getAvailableFleetCardTypeItems = (cards: FleetCardSummary[]) => {
  const existingTypes = new Set(cards.map((card) => card.type))
  return FLEET_CARD_TYPE_OPTIONS.filter((option) => !existingTypes.has(option.id))
}

const SHIPPING_STATUS_LABELS: Record<string, string> = {
  pending: 'Pending',
  submitted: 'Submitted',
  shipped: 'Shipped',
  delivered: 'Delivered',
  returned: 'Returned',
  failure: 'Failure',
  canceled: 'Canceled',
}

export const getFleetCardShippingStatusLabel = (
  status: FleetCardSummary['shippingStatus']
) => {
  if (!status) {
    return 'None'
  }
  return SHIPPING_STATUS_LABELS[status] || status
}

export const getFleetCardPillLabel = (card: FleetCardSummary) => {
  const typeLabel = card.type === 'physical' ? 'Physical' : 'Virtual'
  const base = card.last4 ? `${typeLabel} · ${card.last4}` : typeLabel
  if (!card.shippingStatus) {
    return base
  }
  return `${base} · ${getFleetCardShippingStatusLabel(card.shippingStatus)}`
}

export const getFleetCardPillVariant = (
  card: FleetCardSummary
): ChipVariants => (card.status === 'active' ? 'green' : 'grey')

export const getFleetCardReplacementReasonItems = (card: FleetCardSummary) =>
  FLEET_CARD_REPLACEMENT_REASONS.filter(
    (reason) => !reason.physicalOnly || card.type === 'physical'
  ).map(({ id, text }) => ({ id, text }))
